<template>
  <div class="orders">
    <section class="orders-search">
      <div class="orders-search__upper">
        <h1 class="orders-search__title">Мои заказы</h1>
        <div class="orders-search__form-search__wrapper">
          <span class="orders-search__form-search p-input-icon-left">
            <i class="pi pi-search" />
            <InputText type="text" v-model="inputValue" placeholder="Поиск" />
          </span>
        </div>
      </div>
      <div class="orders-search__form-wrapper">
        <form name="search" class="orders-search__form">
          <div class="p-fluid p-grid p-formgrid">
            <div class="p-field p-col-12 p-md-4">
              <Calendar
                ref="dateSelect"
                id="range"
                v-model="dates2"
                selectionMode="range"
                :manualInput="false"
                :showButtonBar="true"
                :touchUI="true"
                :placeholder="placeholder"
                yearRange="2000:2023"
                :yearNavigator="true"
                @dateSelect="onSelectDate"
              />
            </div>
          </div>
        </form>
        <div class="orders-search__form-select__wrapper">
          <Dropdown
            v-model="selectedState"
            :options="states"
            optionLabel="name"
            placeholder="Статус заказа"
            class="orders-search__form-select"
          />
        </div>
      </div>
    </section>
    <section class="orders-cards">
      <div v-if="this.isLoading">
        <Skeleton class="order-cards__skeleton" width="100%" height="162px" />
        <Skeleton class="order-cards__skeleton" width="100%" height="162px" />
        <Skeleton class="order-cards__skeleton" width="100%" height="162px" />
      </div>
      <div v-else-if="this.error">{{ error }}</div>
      <div
        v-else-if="this.activeOrders.length < 1"
        class="order-cards__notactive"
      >
        <div class="order-cards__notactive-image">
          <img
            :src="require(`../assets/images/globe.svg`)"
            alt=""
            class="order-cards__notactive-image__icon"
          />
        </div>
        <div class="order-cards__notactive-text">
          <p class="order-cards__notactive-text__title">Нет активных заказов</p>
        </div>
      </div>
      <div v-else>
        <order-card
          v-for="userOrder in this.activeOrders"
          :key="userOrder.Id"
          :orders="userOrder"
        />
      </div>
      <div class="orders-cards__more" @click="showAllBtn">
        <button class="orders-cards__more-btn">
          <!-- <div class="orders-cards__more-btn__text">
            </div> -->
          Показать все заказы
        </button>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { ref, watch, watchEffect } from "vue";
import { defineComponent } from "vue";
import Calendar from "primevue/calendar";
import Ripple from "primevue/ripple";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import OrderCard from "../components/OrderCard.vue";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "Orders",
  components: {
    OrderCard,
    Calendar,
    Dropdown,
    InputText,
    Skeleton,
  },
  setup() {
    function getInputFilter() {
      const searchFilter = sessionStorage.getItem("search");
      if (searchFilter) {
        return JSON.parse(searchFilter);
      } else {
        return "";
      }
    }
    function getDateFilter() {
      const dateFilter = sessionStorage.getItem("dates");

      if (dateFilter) {
        const parseDates = JSON.parse(dateFilter);
        return [new Date(parseDates[0]), new Date(parseDates[1])];
      } else {
        return null;
      }
    }
    function getStateNameFilter() {
      const stateNameFilter = sessionStorage.getItem("stateName");
      if (stateNameFilter) {
        return JSON.parse(stateNameFilter);
      } else {
        return "Без фильтрации";
      }
    }
    function getStateCodeFilter() {
      const stateCodeFilter = sessionStorage.getItem("stateCode");
      if (stateCodeFilter) {
        return JSON.parse(stateCodeFilter);
      } else {
        return "99";
      }
    }
    // data for calendar
    const placeholder = "Выберите период";
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevMonth = month === 0 ? 11 : month - 1;
    let prevYear = prevMonth === 11 ? year - 1 : year;
    let nextMonth = month === 11 ? 0 : month + 1;
    let nextYear = nextMonth === 0 ? year + 1 : year;

    const minDate = ref(new Date());
    const maxDate = ref(new Date());
    const invalidDates = ref();
    const dates1 = ref();
    const dates2 = ref(getDateFilter());

    minDate.value.setMonth(prevMonth);
    minDate.value.setFullYear(prevYear);
    maxDate.value.setMonth(nextMonth);
    maxDate.value.setFullYear(nextYear);

    let invalidDate = new Date();
    invalidDate.setDate(today.getDate() - 1);
    invalidDates.value = [today, invalidDate];

    //Data for dropdown select
    let selectedState = ref({
      name: getStateNameFilter(),
      code: getStateCodeFilter(),
    });
    const states = ref([
      { name: "Все заказы", code: "0" },
      { name: "Забронирован", code: "40" },
      { name: "Обрабатывается", code: "55" },
      { name: "Оформлен", code: "60" },
      { name: "Отменён", code: "70" },
    ]);
    const router = useRouter();
    const route = useRoute();
    let inputValue = ref(getInputFilter());
    const isLoading = ref(true);
    const error = ref(null);
    let activeOrders = ref(store.state.orders);
    let userOrders = ref(store.state.orders);
    //Function for filtering only active orders
    const activeUserOrders = (userOrders: any) => {
      let todayDate = new Date();
      let activeOrder = userOrders.filter(function (order: any) {
        return (
          todayDate <= new Date(order.DepInfo.depDate) ||
          todayDate <= new Date(order.DepInfo.backDate)
        );
      });
      activeOrder = activeOrder.sort((a: any, b: any) => {
        let sortDateA = new Date(a.DepInfo.depDate);
        let sortDateB = new Date(b.DepInfo.depDate);
        return +sortDateB - +sortDateA;
      });
      return (activeOrders.value = activeOrder);
    };
    // watch (inputValue, (newValue: any, oldValue: any) => {
    //   console.log(inputValue);
    //   console.log(newValue);
    //   console.log(oldValue);
    // });

    //Fetch GetUserOrders value, sorting it on date, then dispatching store action, then call function
    //for filtering only active orders
    const getOrders = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          "https://www.biletdv.ru/customer/IBEServices/GetUserOrders"
        );
        let fetchedOrders = await json.data.orders;
        userOrders.value = fetchedOrders.sort((a: any, b: any) => {
          let sortDateA = new Date(a.DepInfo.depDate);
          let sortDateB = new Date(b.DepInfo.depDate);
          return +sortDateB - +sortDateA;
        });
        store.dispatch("fetchOrders");
        isLoading.value = false;
        activeUserOrders(userOrders.value);
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    watch(
      [inputValue, selectedState, dates2, userOrders],
      (newValue: any, oldValue: any) => {
        let choosenFilters = {
          dates: dates2.value,
          searchInput: inputValue.value,
          choosenState: selectedState.value,
        };
        if (
          choosenFilters.dates == null &&
          (choosenFilters.choosenState.name == "Все заказы" ||
            choosenFilters.choosenState.name == "Без фильтрации") &&
          choosenFilters.searchInput !== ""
        ) {
          let value: string = choosenFilters.searchInput;
          if (value) {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.destCity.toLowerCase().includes(v)
                  ) ||
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.airlines.toLowerCase().includes(v)
                  ) ||
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) => order.Id.toString().includes(v))
              );
            });
          }
        } else if (
          choosenFilters.dates == null &&
          choosenFilters.choosenState.code == "0" &&
          choosenFilters.searchInput == ""
        ) {
          if (selectedState.value.name == "Все заказы") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 40 ||
                order.State == 55 ||
                order.State == 65 ||
                order.State == 60 ||
                order.State == 70 ||
                order.State == 71 ||
                order.State == 72 ||
                order.State == 73 ||
                order.State == 74
              );
            });
          }
        } else if (
          choosenFilters.dates == null &&
          choosenFilters.choosenState.name !== "Все заказы" &&
          choosenFilters.searchInput == ""
        ) {
          if (selectedState.value.name! == "Забронирован") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return order.State == 40;
            });
          } else if (selectedState.value.name == "Обрабатывается") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return order.State == 55 || order.State == 65;
            });
          } else if (selectedState.value.name == "Оформлен") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return order.State == 60;
            });
          } else if (selectedState.value.name == "Отменён") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 70 ||
                order.State == 71 ||
                order.State == 72 ||
                order.State == 73 ||
                order.State == 74
              );
            });
          }
        } else if (
          choosenFilters.dates !== null &&
          (choosenFilters.choosenState.name == "Все заказы" ||
            choosenFilters.choosenState.name == "Без фильтрации") &&
          choosenFilters.searchInput == ""
        ) {
          if (choosenFilters.dates !== null) {
            let choosedDate = choosenFilters.dates!;

            if (
              choosedDate !== null &&
              choosedDate[0] !== null &&
              choosedDate[1] !== null
            ) {
              activeOrders.value = userOrders.value.filter(function (
                order: any
              ) {
                return (
                  new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                  new Date(order.DepInfo.depDate) <= new Date(choosedDate[1])
                );
              });
            }
          }
        } else if (
          choosenFilters.dates == null &&
          choosenFilters.choosenState.name !== "Все заказы" &&
          choosenFilters.searchInput !== ""
        ) {
          let value: string = choosenFilters.searchInput;
          if (selectedState.value.name! == "Забронирован") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 40 &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          } else if (selectedState.value.name == "Обрабатывается") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                (order.State == 55 || order.State == 65) &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          } else if (selectedState.value.name == "Оформлен") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 60 &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          } else if (selectedState.value.name == "Отменён") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                (order.State == 70 ||
                  order.State == 71 ||
                  order.State == 72 ||
                  order.State == 73 ||
                  order.State == 74) &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          }
        } else if (
          choosenFilters.dates !== null &&
          (choosenFilters.choosenState.name == "Все заказы" ||
            choosenFilters.choosenState.name == "Без фильтрации") &&
          choosenFilters.searchInput !== ""
        ) {
          if (choosenFilters.dates !== null) {
            let value: string = choosenFilters.searchInput;
            let choosedDate = choosenFilters.dates!;

            if (
              choosedDate !== null &&
              choosedDate[0] !== null &&
              choosedDate[1] !== null
            ) {
              activeOrders.value = userOrders.value.filter(function (
                order: any
              ) {
                return (
                  new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                  new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]) &&
                  (value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.depCity.toLowerCase().includes(v)
                    ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) =>
                        order.DepInfo.destCity.toLowerCase().includes(v)
                      ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) =>
                        order.DepInfo.airlines.toLowerCase().includes(v)
                      ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) => order.Id.toString().includes(v)))
                );
              });
            }
          }
        } else if (
          choosenFilters.dates !== null &&
          choosenFilters.choosenState.name !== "Все заказы" &&
          choosenFilters.searchInput == ""
        ) {
          let choosedDate = choosenFilters.dates!;

          if (selectedState.value.name! == "Забронирован") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 40 &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1])
              );
            });
          } else if (selectedState.value.name == "Обрабатывается") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 55 ||
                (order.State == 65 &&
                  new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                  new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]))
              );
            });
          } else if (selectedState.value.name == "Оформлен") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 60 &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1])
              );
            });
          } else if (selectedState.value.name == "Отменён") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                (order.State == 70 ||
                  order.State == 71 ||
                  order.State == 72 ||
                  order.State == 73 ||
                  order.State == 74) &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1])
              );
            });
          }
        } else if (
          choosenFilters.dates !== null &&
          choosenFilters.choosenState.name !== "Все заказы" &&
          choosenFilters.searchInput !== ""
        ) {
          let choosedDate = choosenFilters.dates!;
          let value: string = choosenFilters.searchInput;
          if (selectedState.value.name! == "Забронирован") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 40 &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]) &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          } else if (selectedState.value.name == "Обрабатывается") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 55 ||
                (order.State == 65 &&
                  new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                  new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]) &&
                  (value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.depCity.toLowerCase().includes(v)
                    ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) =>
                        order.DepInfo.destCity.toLowerCase().includes(v)
                      ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) =>
                        order.DepInfo.airlines.toLowerCase().includes(v)
                      ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) => order.Id.toString().includes(v))))
              );
            });
          } else if (selectedState.value.name == "Оформлен") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 60 &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]) &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          } else if (selectedState.value.name == "Отменён") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                (order.State == 70 ||
                  order.State == 71 ||
                  order.State == 72 ||
                  order.State == 73 ||
                  order.State == 74) &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]) &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          }
        }
      }
    );

    return {
      inputValue,
      placeholder,
      dates1,
      dates2,
      minDate,
      maxDate,
      invalidDates,
      selectedState,
      states,
      isLoading,
      error,
      userOrders,
      getOrders,
      activeUserOrders,
      activeOrders,
      getInputFilter,
      getDateFilter,
      getStateNameFilter,
      getStateCodeFilter,
    };
  },

  data() {
    return {};
  },
  created() {
    // Dispatching fetch from store when created
    // then put it in userOrders
    this.getOrders();
  },
  methods: {
    //Method for Show all orders button
    showAllBtn() {
      this.activeOrders = this.userOrders;
      this.selectedState = { name: "Все заказы", code: "0" };
      this.dates2 = null;
      this.inputValue = "";
    },
    //Method for hiding calendar after picking both dates
    onSelectDate() {
      const calendar: any = this.$refs.dateSelect ?? null;
      if (
        calendar &&
        Array.isArray(calendar.modelValue) &&
        calendar.modelValue.length >= 2 &&
        calendar.modelValue[1] == null
      ) {
        calendar.overlayVisible = false;
      }
    },
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    // console.log(this.dates2);
    // console.log(this.inputValue);
    // console.log(this.selectedState);
    if (
      this.dates2 !== null &&
      this.inputValue &&
      this.selectedState !== null &&
      this.selectedState.name !== "Без фильтрации"
    ) {
      sessionStorage.setItem("dates", JSON.stringify(this.dates2));
      sessionStorage.setItem("search", JSON.stringify(this.inputValue));
      sessionStorage.setItem(
        "stateName",
        JSON.stringify(this.selectedState.name)
      );
      sessionStorage.setItem(
        "stateCode",
        JSON.stringify(this.selectedState.code)
      );
    } else if (this.inputValue && this.dates2 !== null) {
      sessionStorage.setItem("search", JSON.stringify(this.inputValue));
      sessionStorage.setItem("dates", JSON.stringify(this.dates2));
      sessionStorage.removeItem("stateName");
      sessionStorage.removeItem("stateCode");
    } else if (
      this.selectedState !== null &&
      this.selectedState.name !== "Без фильтрации" &&
      this.inputValue
    ) {
      sessionStorage.setItem(
        "stateName",
        JSON.stringify(this.selectedState.name)
      );
      sessionStorage.setItem(
        "stateCode",
        JSON.stringify(this.selectedState.code)
      );
      sessionStorage.removeItem("dates");
      sessionStorage.setItem("search", JSON.stringify(this.inputValue));
    } else if (
      this.selectedState !== null &&
      this.selectedState.name !== "Без фильтрации" &&
      this.dates2 !== null
    ) {
      sessionStorage.setItem(
        "stateName",
        JSON.stringify(this.selectedState.name)
      );
      sessionStorage.setItem(
        "stateCode",
        JSON.stringify(this.selectedState.code)
      );
      sessionStorage.setItem("dates", JSON.stringify(this.dates2));
      sessionStorage.removeItem("search");
    } else if (this.dates2 !== null) {
      sessionStorage.setItem("dates", JSON.stringify(this.dates2));
      sessionStorage.removeItem("stateName");
      sessionStorage.removeItem("stateCode");
      sessionStorage.removeItem("search");
    } else if (this.inputValue) {
      sessionStorage.setItem("search", JSON.stringify(this.inputValue));
      sessionStorage.removeItem("stateName");
      sessionStorage.removeItem("stateCode");
    } else if (
      this.selectedState !== null &&
      this.selectedState.name !== "Без фильтрации"
    ) {
      sessionStorage.setItem(
        "stateName",
        JSON.stringify(this.selectedState.name)
      );
      sessionStorage.setItem(
        "stateCode",
        JSON.stringify(this.selectedState.code)
      );
      sessionStorage.removeItem("search");
      sessionStorage.removeItem("dates");
    } else {
      sessionStorage.removeItem("stateName");
      sessionStorage.removeItem("stateCode");
      sessionStorage.removeItem("search");
      sessionStorage.removeItem("dates");
    }
    next();
  },
  computed: {},

  directives: {
    //Directive for ripple styling effect
    ripple: Ripple,
  },
});
</script>

<style lang="scss">
.orders-cards__more-btn:hover {
  background-color: #f5f5f5;
}

@media screen and (max-width: 767px) {
  .special-day {
    text-decoration: line-through;
  }

  .orders-search {
    display: flex;
  }

  .orders-search__upper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    margin-right: 3px;
  }

  .orders-search__form-wrapper {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    justify-content: space-between;
  }

  .orders-search__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    margin-left: 20px;
    margin-top: 4px;
    margin-right: 5px;
    margin-bottom: 5px;
  }

  .orders-search__form {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .orders-search__form-search {
    width: 100%;
  }

  .p-inputtext {
    width: 100%;
  }

  .orders-search__form-select {
    margin-top: 4px;
  }

  .p-dropdown {
    min-width: 188.53px;
  }

  .orders-cards {
    display: flex;
    flex-direction: column;
  }

  .order-cards__skeleton {
    margin-top: 20px;
  }

  .p-skeleton {
    background-color: #ececec !important;
  }

  .order-cards__notactive {
    background-color: #f5f5f5;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    overflow: hidden;
    padding: 25px;
    display: flex;
    margin-top: 25px;
    align-items: center;
  }

  .order-cards__notactive-image__icon {
    width: 40px;
    height: 40px;
  }

  .order-cards__notactive-text {
    margin-left: 15px;
  }

  .order-cards__notactive-text__title {
    font-size: 1rem;
  }

  .orders-cards__more {
    margin-top: 40px;
    align-self: center;
  }

  .orders-cards__more-btn {
    padding: 10px 28px;
    background-color: #ffffff;
    border: 1px solid #ced4da;
    border-radius: 5px;
  }

  .p-ripple .p-ink {
    background: #b8d7ff;
  }

  #range {
    font-size: 14px;
    line-height: 14px;
    color: black;
  }

  .p-inputtext {
    font-size: 16px !important;
    padding-right: 1px !important;
  }

  .p-fluid {
    min-width: 175px;
  }

  .green {
    color: #5ac293;
    width: 33%;
  }
  .p-datepicker-year {
    min-width: 80px !important;
    border-radius: 3px !important;
    font-size: 16px !important;
    line-height: 17px !important;
    color: black;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .special-day {
    text-decoration: line-through;
  }
  .orders-search {
    display: flex;
  }

  .orders-search__upper {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-right: 3px;
  }

  .orders-search__form-wrapper {
    display: flex;
    flex-direction: column;
    margin-left: auto;
  }

  .orders-search__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    margin-left: 20px;
    margin-top: 4px;
    margin-right: 5px;
    margin-bottom: 5px;
  }

  .orders-search__form {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .orders-search__form-search {
    width: 100%;
    margin: 15px 10px 0 0;
  }

  .p-inputtext {
    width: 100%;
    font-size: 16px !important;
    padding-right: 1px !important;
  }

  .orders-search__form-select {
    margin-top: 4px;
  }

  .p-dropdown {
    min-width: 191.53px;
  }

  .orders-cards {
    display: flex;
    flex-direction: column;
  }

  .order-cards__skeleton {
    margin-top: 20px;
  }

  .p-skeleton {
    background-color: #ececec !important;
  }

  .order-cards__notactive {
    background-color: #f5f5f5;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    overflow: hidden;
    padding: 25px;
    display: flex;
    margin-top: 25px;
    align-items: center;
  }

  .order-cards__notactive-image__icon {
    width: 40px;
    height: 40px;
  }

  .order-cards__notactive-text {
    margin-left: 15px;
  }

  .order-cards__notactive-text__title {
    font-size: 1rem;
  }

  .orders-cards__more {
    margin-top: 40px;
    align-self: center;
    cursor: pointer;
  }

  .orders-cards__more-btn {
    font-size: 16px;
    padding: 10px 28px;
    background-color: #ffffff;
    border: 1px solid #ced4da;
    border-radius: 5px;
  }

  .p-ripple .p-ink {
    background: #b8d7ff;
  }

  #range {
    font-size: 16px;
    color: black;
  }

  .p-fluid {
    min-width: 175px;
  }

  .green {
    color: #5ac293;
    width: 33%;
  }
  .p-datepicker-year {
    min-width: 80px !important;
    border-radius: 3px !important;
    font-size: 18px !important;
    color: black;
  }
}

@media screen and (min-width: 1025px) {
  .special-day {
    text-decoration: line-through;
  }
  .orders-search {
    display: flex;
  }

  .orders-search__upper {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-right: 3px;
  }

  .orders-search__form-wrapper {
    display: flex;
    flex-direction: column;
    margin-left: auto;
  }

  .orders-search__title {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    margin-left: 20px;
    margin-right: 5px;
    margin-bottom: 5px;
  }

  .orders-search__form {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .orders-search__form-search {
    width: 100%;
    margin: 14px 10px 0 0;
  }

  .p-inputtext {
    width: 100%;
    font-size: 16px !important;
    padding-right: 1px !important;
  }

  .orders-search__form-select {
    margin-top: 4px;
  }

  .orders-cards {
    display: flex;
    flex-direction: column;
  }

  .order-cards__skeleton {
    margin-top: 20px;
  }

  .p-dropdown {
    min-width: 191.53px;
  }

  .p-skeleton {
    background-color: #ececec !important;
  }

  .order-cards__notactive {
    background-color: #f5f5f5;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    overflow: hidden;
    padding: 25px;
    display: flex;
    margin-top: 25px;
    align-items: center;
  }

  .order-cards__notactive-image__icon {
    width: 40px;
    height: 40px;
  }

  .order-cards__notactive-text {
    margin-left: 15px;
  }

  .order-cards__notactive-text__title {
    font-size: 1rem;
  }

  .orders-cards__more {
    margin-top: 40px;
    align-self: center;
    cursor: pointer;
  }

  .orders-cards__more-btn {
    font-size: 16px;
    padding: 10px 28px;
    background-color: #ffffff;
    border: 1px solid #ced4da;
    border-radius: 5px;
  }

  .p-ripple .p-ink {
    background: #b8d7ff;
  }

  #range {
    font-size: 18px;
    color: black;
  }

  .p-fluid {
    min-width: 175px;
  }

  .green {
    color: #5ac293;
    width: 33%;
  }
  .p-datepicker-year {
    min-width: 80px !important;
    border-radius: 3px !important;
    font-size: 18px !important;
    color: black;
  }
}
</style>
